import React from "react";
import {FormattedMessage} from "react-intl";


const RankingTooltip = ({className,  textId, tooltipStyle, show, children}) => {
    return <div className={`zw-tooltip ${tooltipStyle} ${className}`}>
        <div className={`zw-tooltip__content ranking-tooltip__content ${show ? 'zw-tooltip__content--show':null}`}>
            <FormattedMessage id={textId}/>
        </div>
        {children || null}
    </div>
};

export default RankingTooltip;
